import type { LicenseTenant, LicenseTenantServer } from "@/types/license";

export const normalizeLicenseTenant = (licenseTenant: LicenseTenantServer): LicenseTenant => {
  return {
    type: licenseTenant.type,
    autoRenewal: licenseTenant.auto_renewal,
    renewalDurationMonths: licenseTenant.renewal_duration_months,
    numUsers: licenseTenant.num_users,
    userSeats: licenseTenant.user_seats,
    enableFixedFormPipeline: licenseTenant.enable_fixed_form_pipeline,
    enableLlmIePipeline: licenseTenant.enable_llm_ie_pipeline,
    llmIeSingleFieldLimit: licenseTenant.llm_ie_single_field_limit,
    llmIeTableFieldLimit: licenseTenant.llm_ie_table_field_limit,
    enableManualClassificationPipeline: licenseTenant.enable_manual_classification_pipeline ?? false,
    manualClassificationClassLimit: licenseTenant.manual_classification_class_limit ?? 0,
    enableAutoClassificationPipeline: licenseTenant.enable_auto_classification_pipeline ?? false,
    autoClassificationClassLimit: licenseTenant.auto_classification_class_limit ?? 0,

    currentContractCycle: licenseTenant.current_contract_cycle,
    generalPipelines: licenseTenant.general_pipelines,
  };
};
